module.exports = __webpack_public_path__ + "img/dave.c6be8d75.svg";